/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import PartnerItem from "components/dealerInfo/PartnerItem";
import {Trans} from "react-i18next";

class PartnersTable extends Component {
  state = {
    sort_by: "date", // training name by default
    sort_dir: "desc",
  };

  pName = "";
  pShare = "";
  pDate = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.pName = "";
    this.pShare = "";
    this.pDate = "";

    switch (this.state.sort_by) {
      case "pName":
        this.pName = `_${this.state.sort_dir}`;
        break;
      case "pShare":
        this.pShare = `_${this.state.sort_dir}`;
        break;
      case "pDate":
        this.pDate = `_${this.state.sort_dir}`;
        break;
      default:
        this.pName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = () => {

    if(this.props.data === null)
      return null;

    const sorted = this.props.data.sort((a, b) => {
      switch (this.state.sort_by) {
        case "pDate":
          return this.state.sort_dir === "desc"
            ? new Date(a.partnershipDate) - new Date(b.partnershipDate)
            : new Date(b.partnershipDate) - new Date(a.partnershipDate);
        case "pName":
          return this.state.sort_dir === "desc"
            ? a.dealerPartnerName.localeCompare(b.dealerPartnerName)
            : b.dealerPartnerName.localeCompare(a.dealerPartnerName);
        case "pShare":
          return this.state.sort_dir === "desc"
            ? a.shareholdingPercent - b.shareholdingPercent
            : b.shareholdingPercent - a.shareholdingPercent
        default:
          return this.state.sort_dir === "desc"
            ? a.dealerPartnerName.localeCompare(b.dealerPartnerName)
            : b.dealerPartnerName.localeCompare(a.dealerPartnerName);
      }
    });

    return sorted.map((p) => {
      return (
        <PartnerItem
          key={`${p.dealerPartnerName}-${p.partnershipDate}`}
          partner={p}
        />
      );
    });
  };

  render() {
    this.setSotingClassNames();
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        id="kayitliEgitimler"
        style={{ display: "block" }}
      >
        <table
          className="table display responsive dataTable no-footer dtr-none collapsed"
          id="dataTablePersonel"
        >
          <thead>
            <tr>
              <th
                onClick={() => this.reOrder("pName")}
                className={`all sorting${this.pName}`}
              >
                <div className="tableTitle"><Trans desc="Ad Soyad">10401</Trans></div>
              </th>
              <th
                onClick={() => this.reOrder("pShare")}
                className={`all sorting${this.pShare}`}
              >
                <div className="tableTitle"><Trans desc="Ortaklık Payı">10402</Trans></div>
              </th>
              <th
                onClick={() => this.reOrder("pDate")}
                className={`desktop sorting${this.pDate}`}
              >
                <div className="tableTitle"><Trans desc="Ortaklık Tarihi">10403</Trans></div>
              </th>
            </tr>
          </thead>
          <tbody>{this.renderData()}</tbody>
        </table>
      </div>
    );
  }
}

export default PartnersTable;
